/**
 * Short founder-facing Task titles. Full request text stays inside the Task.
 */
export function taskShortTitle(requestText, fallback = "Untitled Task") {
  const raw = String(requestText || "").trim();
  if (!raw) return fallback;
  const firstLine = raw.split(/\r?\n/)[0].replace(/\s+/g, " ").trim();
  if (/schema keys? behave consistently|letter case|case-insensitive|content-type schema/i.test(firstLine)) {
    return "Case-insensitive schema keys";
  }
  const words = firstLine.split(" ").filter(Boolean);
  if (words.length <= 10) return firstLine.length > 72 ? `${words.slice(0, 8).join(" ")}` : firstLine;
  return words.slice(0, 8).join(" ");
}

export function taskRequestFingerprint(requestText) {
  return String(requestText || "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 96);
}

export function findSimilarActiveTask(plans, requestText, { excludeId } = {}) {
  const needle = taskRequestFingerprint(requestText);
  if (needle.length < 12) return null;
  const active = (plans || []).filter((plan) => {
    if (excludeId && String(plan._id) === String(excludeId)) return false;
    const status = String(plan.status || "").toLowerCase();
    return status !== "failed" && status !== "rejected";
  });
  return (
    active.find((plan) => taskRequestFingerprint(plan.featureRequestText) === needle) ||
    active.find((plan) => taskRequestFingerprint(plan.featureRequestText).startsWith(needle.slice(0, 40))) ||
    null
  );
}

export function isEvaluationTask(plan) {
  const origin = String(plan?.originKind || plan?.origin?.kind || "").toLowerCase();
  if (["evaluation", "test", "fixture", "disposable"].includes(origin)) return true;
  const text = String(plan?.featureRequestText || "").replace(/\s+/g, " ").trim();
  if (
    /^(Show me how |Explain how |How does |Where would I )/i.test(text) &&
    !/schema keys|without breaking/i.test(text)
  ) {
    return true;
  }
  return Boolean(plan?.evalSuite || plan?.evaluationRunId || plan?.disposable);
}
